import PropTypes from 'prop-types';

const propType = PropTypes.shape({
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
});

export default propType;
